import AbstractGuestlistDetailsPageController from '../abstract-details-controller';

export default class GuestlistOverviewPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);
        this.dataLoading = false;
        this.data = {};
        this.templatesStore = null;
        this.rawTemplates = null;
    }

    $onInit() {
        super.$onInit();
        this._loadData();
    }

    _loadLineStatistic() {
        const data = this.data.messageStatesLast7Days
        this.series = Object.keys(data);
        this.xLegend = Object.keys(data[this.series[0]]);
        this.values = this.series.map(key => {
            return Object.values(data[key])
        });

        this.scope.labels = this.xLegend;
        this.scope.series = this.series;
        this.scope.values = this.values;
        this.scope.graphColors = ['#e01249', '#9499da', '#9c62ff', '#04cac3', '#f5b858']

        const maxValue = this.values.reduce((carry, value) => {
            const max = Math.max(...value);
            if (max > carry) {
                return max;
            }
            return carry;
        }, 1);


        this.scope.onClick = function (points, evt) {
            console.log(points, evt);
        };

        this.scope.datasetOverride = [{
            yAxisID: 'y-axis-1',
            fill: false,
            lineTension: 0
        },
            {fill: false, lineTension: 0},
            {fill: false, lineTension: 0},
            {fill: false, lineTension: 0},
            {fill: false, lineTension: 0},
        ];

        this.scope.options = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left',
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            beginAtZero: true,
                            precision: 0,
                            stepSize: Math.round(maxValue / 4),
                            max: maxValue,
                            maxTicksLimit: maxValue < 4 ? 1 : 4,
                        }

                    },
                ],
                xAxes: [{
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                    }
                }]
            }
        };
    }

    _loadData() {
        this.dataLoading = true;
        this.api
            .get(`stats/guestlists/${this.currentGuestlistId}/messages`)
            .then(({data}) => {
                this.data = data;
                this.dataLoading = false;
                this._loadLineStatistic();
            })
            .catch(e => {
                this.dataLoading = false;
            });
    }


    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this.store = this.injector
            .get('Messages')
            .reset({
                listview: `Guestlist${this.guestlist.id}MessagesListView`,
                persist: false,
                pagination: {
                    perPage: 5,
                },
                sort: {
                    created_at: 'desc'
                }
            });
        this.store.commit('setVm', this);
        this.store.commit('setPrefix', `guestlists/${this.guestlist.id}`)
        this.store.dispatch('loadWorkflows', 'messages::list');
        this.store.commit('setColumns', [
            {
                key: 'id',
                type: 'integer',
                visible: true
            },
            {
                key: 'subject',
                type: 'string',
                visible: true
            },
            {
                key: 'contact.full_name',
                type: 'string',
                visible: true
            },
            {
                key: 'send_to',
                type: 'string',
                visible: true
            },
            {
                key: 'status',
                type: 'string',
                visible: true
            },
            {
                key: 'created_at',
                type: 'string',
                visible: true
            }
        ]);
        this.store.dispatch('getData');
    }

    formatDate(date) {
        date = new Date(date)
        return date.toLocaleDateString('de-DE');
    }

    goToMessagesLink() {
        this.state.go('app.guestlists.rsvps.messages.sent', this.stateParams);
    }

    goToTemplateLink() {
        this.state.go('app.guestlists.rsvps.messages.templates', this.stateParams);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/messages/overview-controller.js